<span>
  {{ title() }}
</span>
@if (file(); as _file) {
  <div class="flex flex-row space-x-1 px-2">
    <div class="flex items-center">
      <shared-core-material-icon class="pr-2" [name]="'description'" />
      <p class="text-sm font-semibold">{{ _file.name }}</p>
    </div>
    <button
      (click)="deleteFile()"
      class="text-theme-gray-800 hover:text-theme-danger col-span-1 row-span-2 flex h-12 w-12 shrink-0 items-center justify-center rounded text-xs font-semibold transition hover:cursor-pointer">
      <shared-core-material-icon [name]="'delete'" />
    </button>
  </div>
} @else {
  <div
    class="flex w-full items-center justify-center"
    (dragover)="preventDefaultAndStopPropagation($event)"
    (dragleave)="preventDefaultAndStopPropagation($event)"
    (drop)="onDropFile($event)">
    <label
      class="flex h-64 w-full cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-200 hover:bg-gray-300"
      [ngClass]="{ 'border-red-500': !valid() }">
      <div class="flex flex-col items-center justify-center pt-5 pb-6">
        <shared-core-material-icon class="mb-3 h-10 w-10 text-gray-400" [name]="'file_upload'" />
        <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">
          Ziehen Sie die Datei hier rein oder
        </p>
        <p class="mb-2 text-sm text-gray-500 dark:text-gray-400">wählen Sie die Datei aus.</p>
        <p class="text-xs text-gray-500 dark:text-gray-400">Unterstütztes Format: PDF (max. 7MB)</p>
      </div>
      <input type="file" class="hidden" (change)="addFile($event)" accept="application/pdf" />
    </label>
  </div>
}
